"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSubItemFieldValue = void 0;
const typing_1 = require("./typing");
const arrays_1 = require("./arrays");
const custom_types_1 = require("./custom-types");
const dates_1 = require("./dates");
const number_1 = require("./number");
const primitives_1 = require("./primitives");
const create_updated_1 = require("./create-updated");
const isSubItemFieldValue = (fieldValue) => {
    const items = fieldValue.items;
    if ((0, primitives_1.isNullValue)(items))
        return false;
    const isItemsValid = (0, arrays_1.isArrayOfValidObjectsValue)(items !== null && items !== void 0 ? items : [], // items are optional
    {
        first_created: create_updated_1.isCreatedUpdatedFieldValue,
        last_updated: create_updated_1.isCreatedUpdatedFieldValue,
        id: (0, typing_1.Optional)(custom_types_1.isIDValue),
        deleted_date: (0, typing_1.Optional)(dates_1.isDateValue),
    }, true);
    const isCountValid = (0, number_1.isNotNegativeNumberValue)(fieldValue.count);
    return isItemsValid && isCountValid;
};
exports.isSubItemFieldValue = isSubItemFieldValue;
